import useResponsiveActionWindow from './useResponsiveActionWindow'

export default useResponsiveActionWindow
